/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiDocumentsDtoCompanyDocumentDto,
  WebApiDocumentsDtoCompanyDocumentListDto,
} from '../models';
import {
    WebApiDocumentsDtoCompanyDocumentDtoFromJSON,
    WebApiDocumentsDtoCompanyDocumentDtoToJSON,
    WebApiDocumentsDtoCompanyDocumentListDtoFromJSON,
    WebApiDocumentsDtoCompanyDocumentListDtoToJSON,
} from '../models';

export interface ApiDocumentDownloadIdGetRequest {
    id: number;
}

export interface ApiDocumentIdDeleteRequest {
    id: number;
}

export interface ApiDocumentPostRequest {
    overwrite?: boolean;
    file?: Blob;
}

/**
 * 
 */
export class DocumentApi extends runtime.BaseAPI {

    /**
     */
    async apiDocumentDownloadIdGetRaw(requestParameters: ApiDocumentDownloadIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDocumentDownloadIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Document/download/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDocumentDownloadIdGet(requestParameters: ApiDocumentDownloadIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDocumentDownloadIdGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDocumentGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiDocumentsDtoCompanyDocumentListDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Document`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiDocumentsDtoCompanyDocumentListDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiDocumentGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiDocumentsDtoCompanyDocumentListDto> {
        const response = await this.apiDocumentGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDocumentIdDeleteRaw(requestParameters: ApiDocumentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDocumentIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDocumentIdDelete(requestParameters: ApiDocumentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDocumentIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDocumentPostRaw(requestParameters: ApiDocumentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiDocumentsDtoCompanyDocumentDto>> {
        const queryParameters: any = {};

        if (requestParameters.overwrite !== undefined) {
            queryParameters['overwrite'] = requestParameters.overwrite;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/Document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiDocumentsDtoCompanyDocumentDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiDocumentPost(requestParameters: ApiDocumentPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiDocumentsDtoCompanyDocumentDto> {
        const response = await this.apiDocumentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
